<template>
  <modal
    :title="setModel != undefined ? 'Update Seasons' : 'Add Seasons'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        @submit="onSubmit"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
        <formGroup
          :title="'Type'"
                as="select"
          v-model.number="model.FieldType"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        >
                <template #input>
                    <option value="1">Agency</option>
                    <option value="2">Provider</option>
                  </template>
        
        </formGroup>
        <formGroup
          :title="'Value'"
          v-model="model.FieldValue"
          :rules="{ required: true }"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'Active'"
          :as="'checkbox'"
          v-model="model.IsActive"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Code" : "Add Code"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    addId: Number,
  },
  data() {
    return {
      model: {
          "HotelId":this.addId,
          "FieldType":1,
          "FieldValue":"",
          "IsActive":true
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`Hotels/FidelioUnbillings`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The unbillings has been successfully updated."
                    : "The unbillings has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
